export default "__VITE_ASSET__XwQFK0YD__"